"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APP_PROMO_BANNER_OPEN = exports.APP_PROMO_BANNER_LABEL = exports.APP_PROMO_BANNER_ICON = exports.APP_PROMO_BANNER_HEIGHT = exports.APP_PROMO_BANNER_CLOSE = exports.APP_PROMO_BANNER = void 0;
const APP_PROMO_BANNER = exports.APP_PROMO_BANNER = 'app-promo-banner';
const APP_PROMO_BANNER_CLOSE = exports.APP_PROMO_BANNER_CLOSE = 'app-promo-banner-close';
const APP_PROMO_BANNER_OPEN = exports.APP_PROMO_BANNER_OPEN = 'app-promo-banner-open';
const APP_PROMO_BANNER_ICON = exports.APP_PROMO_BANNER_ICON = 'app-promo-banner-icon';
const APP_PROMO_BANNER_HEIGHT = exports.APP_PROMO_BANNER_HEIGHT = 82;
const APP_PROMO_BANNER_LABEL = exports.APP_PROMO_BANNER_LABEL = 'app-promo-banner-label';